import React, { useEffect } from 'react';
import { Stack } from '@mantine/core';
import EventLoading from '../EventLoading';
import { CateringUpcomingChecklist } from './CateringUpcoming.checklist';
import { CateringEventVendorDetailsUpcoming } from '../types';
import { EventHeading } from '../EventHeadings/EventHeading';
import { EventDetails } from '../shared/Event.details';
import { getFullLocationAddress } from '@/pages/Dashboard.page/helpers';
import { EventDownload } from '../shared/Event.download';
import { cateringtDownloadConfig } from './config';
import { getRestaurantInfo } from '../helpers';
import { useCateringUpcomingEvent } from './useCateringUpcomingEvent';
import useTrackEvent from '../useTrackEvent';

export const CateringUpcoming: React.FC<{ id: string; onCloseWithoutEvent: () => void }> = ({
  id,
  onCloseWithoutEvent,
}) => {
  const { event, loading } = useCateringUpcomingEvent(id);

  useTrackEvent(event);

  useEffect(() => {
    if (!loading && !event) {
      onCloseWithoutEvent();
    }
  }, [loading, event, onCloseWithoutEvent]);

  if (loading) {
    return <EventLoading />;
  }

  if (!event) {
    return <></>;
  }
  const eventTitle = `${event.productType.toLowerCase()} Event Details ${
    event.event.name ? ` - ${event.event.name}` : ''
  }`;

  const eventDetails = {
    startTime: event.event.startTime,
    setupTime: event.event?.setupTime || event.event.startTime,
    endTime: event.event?.endTime,
    restaurant: getRestaurantInfo(
      event.vendor?.internalName,
      event.vendor?.address,
      event.event.location
    ),
    placeName: event.event.account.name,
    locationAddress: getFullLocationAddress(event.event.location),
  };
  const eventDownloadDetails = {
    ...cateringtDownloadConfig,
    leftDownloadUrl: event.packingSlipUrl || '',
    rightDownloadUrl: event.purchaseOrderUrl || '',
  };
  return (
    <EventHeading eventStartTime={event.event.startTime} title={eventTitle}>
      <Stack gap="md">
        <EventDetails eventDetails={eventDetails} />
        <CateringUpcomingChecklist event={event} />
        <EventDownload eventDownloadDetails={eventDownloadDetails} />
      </Stack>
    </EventHeading>
  );
};

